import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
//import { NotifyService } from '../../../../core/services/notify.service';

@Component({
  selector: 'manual-tab',
  templateUrl: './manual-tab.component.html',
  styleUrls: ['./manual-tab.component.scss'],
})
export class ManualTabComponent implements OnInit {
  margin: string = '0px';

  constructor(
    // private toast: NotifyService,
    private readonly scroller: ViewportScroller
  ) {}

  ngOnInit(): void {
    window.addEventListener('scroll', (e: Event) => {
      if (window.screen.width >= 768) {
        const scrollTop =
          window.scrollY ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        if (scrollTop == 0) {
          this.margin = '0px';
        } else {
          this.margin = `${scrollTop}px`;
        }
      }
    });
  }

  scrollInToView(attrID: string) {
    const text = document.getElementById(attrID);
    if (!text) return;
    this.scroller.scrollToPosition([0, text.offsetTop + 9 * -16]);
    if (window.screen.width >= 768) {
      this.margin = `${text.offsetTop + 9 * -16}px`;
    }
  }

  /* public copyText(tag: HTMLElement) {
    if (tag.tagName != 'I') return;
    const text = tag.attributes[2].value.replace(/'/g, '"');
    navigator.clipboard.writeText(text);
    this.toast.toastr(
      'success',
      'Se ha copia en portapapeles',
      'Texto',
      1000,
      'top-right'
    );
  }*/
}
